export const enum PAYLATER_TYPES {
    LAZYPAY = "PayLater_Lazypay",
    PAYTM_POSTPAID = "PayTM_PostPaid",
    SIMPL = "PayLater_Simpl",
    AMAZON_PAYLATER = "AmazonPayLater",
}

export const PAYLATER_DISPLAY_NAMES = {
    [PAYLATER_TYPES.LAZYPAY]: "Lazypay",
    [PAYLATER_TYPES.PAYTM_POSTPAID]: "Paytm",
    [PAYLATER_TYPES.SIMPL]: "Simpl",
    [PAYLATER_TYPES.AMAZON_PAYLATER]: "Amazon Pay Later",
};
